import {
  App as AntApp,
  ConfigProvider,
  adminDarkTheme,
  adminTheme,
} from '@wanjianshi/admin-ui';
import zhCN from 'antd/locale/zh_CN';
import type { ReactNode } from 'react';
import { AdminThemeModeProvider, useAdminThemeMode } from './theme-mode';

function AntDesignProvider({ children }: { children: ReactNode }) {
  const { mode } = useAdminThemeMode();

  return (
    <ConfigProvider
      locale={zhCN}
      componentSize="middle"
      theme={mode === 'dark' ? adminDarkTheme : adminTheme}
    >
      <AntApp>{children}</AntApp>
    </ConfigProvider>
  );
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AdminThemeModeProvider>
      <AntDesignProvider>{children}</AntDesignProvider>
    </AdminThemeModeProvider>
  );
}
